import api from './api';

const TeacherSubjectService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/teacher-subjects/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/teacher-subjects/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/teacher-subjects/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/teacher-subjects/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/teacher-subjects/${id}/`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/teacher-subjects/${id}/`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default TeacherSubjectService;
